import React, { createElement } from 'react';
import './index.css';
import { render } from 'react-dom';
import { App } from './App';
// ============================================
// CRITICAL: Set SEO meta tags IMMEDIATELY (synchronously)
// This runs before any async code to ensure crawlers see it
// ============================================
// Detect language from URL path
const currentPath = window.location.pathname;
let currentLang = 'en';
if (currentPath.startsWith('/ru')) currentLang = 'ru';else if (currentPath.startsWith('/ua') || currentPath.startsWith('/uk')) currentLang = 'ua';
// SEO data for each language
const seoData: Record<string, {
  title: string;
  description: string;
}> = {
  en: {
    title: 'IT Monsters | Professional Web Design & Development',
    description: 'IT Monsters is a professional IT studio. We design and develop websites of any complexity. Get a free demo in 1–3 days. Remote team, worldwide.'
  },
  ru: {
    title: 'IT Monsters | Профессиональная разработка сайтов',
    description: 'IT Monsters — профессиональная IT-студия. Создаем сайты любой сложности. Сначала делаем бесплатное демо (1–3 дня). Работаем онлайн по всему миру.'
  },
  ua: {
    title: 'IT Monsters | Професійна розробка сайтів',
    description: 'IT Monsters — професійна IT-студія. Створюємо сайти будь-якої складності. Спочатку робимо безкоштовне демо (1–3 дні). Працюємо онлайн по всьому світу.'
  }
};
const seo = seoData[currentLang] || seoData.en;
// Set document title IMMEDIATELY
document.title = seo.title;
// Set lang attribute
document.documentElement.lang = currentLang === 'ua' ? 'uk' : currentLang;
// Create and insert meta description
const metaDesc = document.createElement('meta');
metaDesc.name = 'description';
metaDesc.content = seo.description;
document.head.appendChild(metaDesc);
// Calculate URLs
const baseUrl = 'https://itmonsters.agency'; // Assuming new domain or keep old if unknown, but branding is IT Monsters
const langPrefix = currentLang === 'en' ? '' : `/${currentLang}`;
let pagePath = currentPath;
if (currentPath.startsWith('/ru') || currentPath.startsWith('/ua') || currentPath.startsWith('/uk')) {
  pagePath = currentPath.substring(3) || '';
}
const canonicalUrl = `${baseUrl}${langPrefix}${pagePath}`;
// Canonical
const linkCanonical = document.createElement('link');
linkCanonical.rel = 'canonical';
linkCanonical.href = canonicalUrl;
document.head.appendChild(linkCanonical);
// Open Graph tags
const ogMeta = [{
  property: 'og:title',
  content: seo.title
}, {
  property: 'og:description',
  content: seo.description
}, {
  property: 'og:url',
  content: canonicalUrl
}, {
  property: 'og:type',
  content: 'website'
}, {
  property: 'og:site_name',
  content: 'IT Monsters'
}, {
  property: 'og:locale',
  content: currentLang === 'en' ? 'en_US' : currentLang === 'ru' ? 'ru_RU' : 'uk_UA'
}];
ogMeta.forEach(({
  property,
  content
}) => {
  const meta = document.createElement('meta');
  meta.setAttribute('property', property);
  meta.content = content;
  document.head.appendChild(meta);
});
// Twitter Card tags
const twitterMeta = [{
  name: 'twitter:card',
  content: 'summary_large_image'
}, {
  name: 'twitter:title',
  content: seo.title
}, {
  name: 'twitter:description',
  content: seo.description
}];
twitterMeta.forEach(({
  name,
  content
}) => {
  const meta = document.createElement('meta');
  meta.name = name;
  meta.content = content;
  document.head.appendChild(meta);
});
// Hreflang tags
const langs = ['en', 'ru', 'ua'];
langs.forEach(l => {
  const link = document.createElement('link');
  link.rel = 'alternate';
  link.hreflang = l === 'ua' ? 'uk' : l;
  link.href = `${baseUrl}${l === 'en' ? '' : `/${l}`}${pagePath}`;
  document.head.appendChild(link);
});
// x-default
const xDefaultLink = document.createElement('link');
xDefaultLink.rel = 'alternate';
xDefaultLink.hreflang = 'x-default';
xDefaultLink.href = `${baseUrl}${pagePath}`;
document.head.appendChild(xDefaultLink);
// ============================================
// Google Tag (gtag.js) - AW-16744119758
// ============================================
const GOOGLE_ADS_ID = 'AW-16744119758';
const gtagScript = document.createElement('script');
gtagScript.async = true;
gtagScript.src = `https://www.googletagmanager.com/gtag/js?id=${GOOGLE_ADS_ID}`;
document.head.appendChild(gtagScript);
declare global {
  interface Window {
    dataLayer: any[];
    gtag: (...args: any[]) => void;
  }
}
window.dataLayer = window.dataLayer || [];
window.gtag = function gtag() {
  window.dataLayer.push(arguments);
};
window.gtag('js', new Date());
window.gtag('config', GOOGLE_ADS_ID);
// ============================================
// Render App
// ============================================
render(<App data-id="element-357" />, document.getElementById('root'));